import {Grid} from "@material-ui/core";
import FormHelperText from "@material-ui/core/FormHelperText";
import _ from "lodash";
import React, {useState} from "react";
import {BEAUFTRAGTER, BETREIBER, FACHADMIN, SYSTEMADMIN, ZUST_SBD} from "../../../consts/funktionaleRollen";
import {REGEX_TELEFONNUMMER} from "../../../consts/regex";
import {getBearbeiter} from "../../../services/BetriebeService";
import {getAnredeEndpoint, getTitelEndpoint, getZustaendigkeitPersonEndpoint} from "../../../services/WertelistenService";
import {logger} from "../../../services/LogService";
import {ASC, sortBy} from "../../../utils/ArrayUtils";
import {createCalculatedColumn, createColumn, createComponentColumn} from "../../../utils/ColumnUtils";
import {userHasAnyRole} from "../../../utils/SecurityUtils";
import {useHttpSortById, usePreformattedHttp} from "../../../utils/usePreformattedHttp";
import {regex, requiredString, requiredWerteListeObjekt, validate, VALIDATION_MESSAGE_TELEFON, validEmail,} from "../../../utils/Validator";
import {confirmDeleteOption} from "../../ConfirmationDialog/confirmationDialogOptions";
import {useConfirmation} from "../../ConfirmationDialog/ConfirmationDialogProvider";
import PersonalDataComponent from "../../data/user/PersonalDataComponent";
import EAButton from "../../EAButton";
import EAButtonBar from "../../EAButtonBar";
import EACombobox from "../../EACombobox";
import EADialog from "../../EADialog";
import EATable from "../../EATable";
import EATextField from "../../EATextField";
import EATableActionButton from "../../tableComponents/EATableActionButton";
import {getPersonByLokaleRolleConnectedToBetriebEndpoint} from "../../../services/AnwenderService";

function Zustaendigkeiten(props) {
    const confirm = useConfirmation();
    const [personenOptionen] = useHttpSortById(getPersonByLokaleRolleConnectedToBetriebEndpoint(props.betriebsId), {manual: !props.betriebsId});
    const [zustaendigkeitPersonenOptionen] = useHttpSortById(getZustaendigkeitPersonEndpoint);
    const [bearbeiterOptionen] = usePreformattedHttp((data) => sortBy(data, "datascoutId", ASC), getBearbeiter);
    const [titelOptions] = useHttpSortById(getTitelEndpoint);
    const [anredeOptions] = useHttpSortById(getAnredeEndpoint);
    const [tmpPerson, setTmpPerson] = useState(null);
    const [tmpPersonZustaendigkeit, setTmpPersonZustaendigkeit] = useState([]);
    const [dlgKontaktOpen, setDlgKontaktOpen] = useState(false);
    const initialKontakt = {
        anrede: null,
        titel: null,
        name: "",
        vorname: "",
        email: "",
        telefon: "",
        mobil: "",
        funktion: "",
    };
    const [tmpKontakt, setTmpKontakt] = useState(initialKontakt);
    const schema = {
        anrede: requiredWerteListeObjekt(),
        name: requiredString("Name"),
        vorname: requiredString("Vorname"),
        email: validEmail("E-Mail"),
        telefon: regex(REGEX_TELEFONNUMMER, true, VALIDATION_MESSAGE_TELEFON),
        mobil: regex(REGEX_TELEFONNUMMER, false, VALIDATION_MESSAGE_TELEFON),
    };
    const [errors, setErrors] = useState({});
    const [dlgPersonOpen, setDlgPersonOpen] = useState(false);
    const [dlgBearbeiterOpen, setDlgBearbeiterOpen] = useState(false);
    const [kontaktIndex, setKontaktIndex] = useState(-1);
    const [bearbeiterIndex, setBearbeiterIndex] = useState(-1);
    const [personIndex, setPersonIndex] = useState(-1);

    function renderKontakte() {
        return (
            <React.Fragment>
                <div style={{gridColumn: "span 2"}}>Kontakte</div>
                <div style={{gridColumn: "span 2"}}>
                    <EATable
                        id="kontakte"
                        initialSortColumn="kontakt.name"
                        columns={[
                            createComponentColumn(
                                "actions",
                                (row, index) => {
                                    if (isDisabled()) return <div/>;
                                    return (
                                        <Grid container spacing={1} justify="center">
                                            <Grid item>
                                                <EATableActionButton id={"kontakte-edit-" + index} iconName="ico-edit">
                                                    <span
                                                        onClick={() => handleKontaktEdit(index)}
                                                        className={"w-100"}
                                                        style={{
                                                            height: "100%",
                                                            display: "block",
                                                        }}
                                                    />
                                                </EATableActionButton>
                                            </Grid>
                                            <Grid item>
                                                <EATableActionButton id={"kontakte-delete-" + index} iconName="ico-delete">
                                                    <span
                                                        onClick={() => handleKontaktDelete(index)}
                                                        className={"w-100"}
                                                        style={{
                                                            height: "100%",
                                                            display: "block",
                                                        }}
                                                    />
                                                </EATableActionButton>
                                            </Grid>
                                        </Grid>
                                    );
                                },
                                "",
                                null,
                                {width: "50px", padding: "0"}
                            ),
                            createCalculatedColumn(
                                "kontakt.name",
                                (row) => {
                                    return <label>{row.vorname + " " + row.name}</label>;
                                },
                                "Name"
                            ),
                            createColumn("telefon", "Telefon"),
                            createColumn("email", "E-Mail"),
                            createColumn("funktion", "Funktion"),
                        ]}
                        data={props.data.kontakte}
                    />
                </div>
                {props.errors && props.errors.kontakte && (
                    <FormHelperText id="kontakte-helper-text" error>
                        {props.errors.kontakte}
                    </FormHelperText>
                )}
                <div style={{gridColumnStart: "2", placeSelf: "end"}}>
                    {props.formFactory.renderButton(
                        "addKontakt",
                        "addKontakt",
                        "Hinzufügen",
                        () => {
                            setKontaktIndex(-1);
                            setDlgKontaktOpen(true);
                        },
                        {
                            "data-cy": "addKontakt",
                        }
                    )}
                </div>
            </React.Fragment>
        );
    }

    function handleKontaktChanged(field, value) {
        setTmpKontakt({...tmpKontakt, [field]: value});
    }

    function handleKontaktDelete(index) {
        if (isDisabled()) {
            return;
        }

        confirm(
            confirmDeleteOption(
                "den Kontakt",
                () => {
                    removeKontakt(index);
                },
                () => {
                }
            )
        );
    }

    function removeKontakt(index) {
        const kontakte = [...props.data.kontakte];
        kontakte.splice(index, 1);
        props.onChange("kontakte", kontakte);
        setTmpKontakt(initialKontakt);
    }

    function handleClickKontaktOpen() {
        setDlgKontaktOpen(true);
    }

    function handleKontaktClose() {
        setDlgKontaktOpen(false);
        setKontaktIndex(-1);
        setTmpKontakt(initialKontakt);
        setErrors({});
    }

    function handleKontaktEdit(index) {
        if (isDisabled()) {
            return;
        }
        setKontaktIndex(index);
        setTmpKontakt(props.data.kontakte[index]);
        handleClickKontaktOpen();
    }

    function handleKontaktCloseOk() {
        const valid = isKontaktValid();
        if (!valid) {
            return;
        }
        setDlgKontaktOpen(false);
        const kontakte = [...props.data.kontakte];
        if (kontaktIndex === -1) {
            kontakte.push({...tmpKontakt});
        } else {
            kontakte[kontaktIndex] = {...kontakte[kontaktIndex], ...tmpKontakt};
        }
        logger.debug("KontaktClose", kontakte);
        setKontaktIndex(-1);
        setTmpKontakt(initialKontakt);
        setErrors({});
        props.onChange("kontakte", kontakte);
    }

    function isKontaktValid() {
        const newErrors = validate(tmpKontakt, schema, {abortEarly: false, stripUnknown: true});
        setErrors(newErrors || {});
        return !newErrors;
    }

    function handlePersonDelete(index) {
        if (isDisabled()) {
            return;
        }

        confirm(
            confirmDeleteOption(
                "die Person",
                () => {
                    removePerson(index);
                },
                () => {
                }
            )
        );
    }

    function removePerson(index) {
        const zustaendigePersonen = [...props.data.zustaendigePersonen];
        zustaendigePersonen.splice(index, 1);
        props.onChange("zustaendigePersonen", zustaendigePersonen);
        setTmpPerson(null);
        setTmpPersonZustaendigkeit([]);
    }

    function handleClickPersonOpen() {
        setDlgPersonOpen(true);
    }

    function handlePersonClose() {
        setDlgPersonOpen(false);
        setPersonIndex(-1);
        setTmpPerson(null);
        setTmpPersonZustaendigkeit([]);
    }

    function handlePersonChange(e, newValue) {
        setTmpPerson(newValue);
    }

    function handlePersonZustaendigkeitChange(e, newValue) {
        setTmpPersonZustaendigkeit(newValue);
    }

    function handlePersonEdit(index) {
        if (isDisabled()) {
            return;
        }
        setPersonIndex(index);
        setTmpPerson(props.data.zustaendigePersonen[index].person);
        setTmpPersonZustaendigkeit(props.data.zustaendigePersonen[index].zustaendig);
        handleClickPersonOpen();
    }

    function handlePersonCloseOk() {
        const valid = isPersonValid();
        if (!valid) {
            return;
        }
        setDlgPersonOpen(false);
        const zustaendigePersonen = [...props.data.zustaendigePersonen];
        if (personIndex === -1) {
            zustaendigePersonen.push({
                person: tmpPerson,
                zustaendig: tmpPersonZustaendigkeit,
            });
        } else {
            zustaendigePersonen[personIndex] = {
                ...zustaendigePersonen[personIndex],
                person: tmpPerson,
                zustaendig: tmpPersonZustaendigkeit,
            };
        }
        logger.debug("PersonClose", zustaendigePersonen);
        setPersonIndex(-1);
        setTmpPerson(null);
        setTmpPersonZustaendigkeit([]);
        props.onChange("zustaendigePersonen", zustaendigePersonen);
    }

    function isPersonValid() {
        return tmpPerson && !!(tmpPerson.id && tmpPersonZustaendigkeit && tmpPersonZustaendigkeit.length);
    }

    function handleBearbeiterDelete(index) {
        if (isDisabled()) {
            return;
        }

        confirm(
            confirmDeleteOption(
                "den Bearbeiter",
                () => {
                    removeBearbeiter(index);
                },
                () => {
                }
            )
        );
    }

    function removeBearbeiter(index) {
        const zustaendigeBearbeiter = [...props.data.zustaendigeBearbeiter];
        zustaendigeBearbeiter.splice(index, 1);
        props.onChange("zustaendigeBearbeiter", zustaendigeBearbeiter);
        setTmpPerson(null);
        setTmpPersonZustaendigkeit([]);
    }

    function handleClickBearbeiterOpen() {
        if (isDisabled()) {
            return;
        }
        setDlgBearbeiterOpen(true);
    }

    function handleBearbeiterClose() {
        setDlgBearbeiterOpen(false);
        setTmpPerson(null);
        setTmpPersonZustaendigkeit([]);
        setBearbeiterIndex(-1);
    }

    function handleBearbeiterChange(e, newValue) {
        setTmpPerson(newValue);
    }

    function handleBearbeiterEdit(index) {
        if (isDisabled()) {
            return;
        }
        setBearbeiterIndex(index);
        setTmpPerson(props.data.zustaendigeBearbeiter[index].bearbeiter);
        setTmpPersonZustaendigkeit(props.data.zustaendigeBearbeiter[index].zustaendig);
        handleClickBearbeiterOpen();
    }

    function handleBearbeiterCloseOk() {
        const valid = isBearbeiterValid();
        if (!valid) {
            return;
        }
        setDlgBearbeiterOpen(false);
        const zustaendigeBearbeiter = [...props.data.zustaendigeBearbeiter];
        if (bearbeiterIndex === -1) {
            zustaendigeBearbeiter.push({
                bearbeiter: tmpPerson,
                zustaendig: tmpPersonZustaendigkeit,
            });
        } else {
            zustaendigeBearbeiter[bearbeiterIndex] = {
                ...zustaendigeBearbeiter[bearbeiterIndex],
                bearbeiter: tmpPerson,
                zustaendig: tmpPersonZustaendigkeit,
            };
        }
        logger.debug("BearbeiterClose", zustaendigeBearbeiter);
        setBearbeiterIndex(-1);
        setTmpPerson(null);
        setTmpPersonZustaendigkeit([]);
        props.onChange("zustaendigeBearbeiter", zustaendigeBearbeiter);
    }

    function isBearbeiterValid() {
        return tmpPerson?.datascoutId;
    }

    function isDisabled() {
        if (!props.parentId) return false;
        if (props.modus === "l") {
            return true;
        }
        if (props.modus === "s") {
            return !userHasAnyRole([BETREIBER, BEAUFTRAGTER, FACHADMIN, SYSTEMADMIN, ZUST_SBD]);
        }
        return true;
    }

    return (
        <div className="gridl gridForZustaendigkeiten tabsheet-content-margin">
            <div style={{gridColumn: "span 2"}}>Zuständigkeiten Betrieb</div>
            <div style={{gridColumn: "span 2"}}>
                <EATable
                    id="zustaendigePersonen"
                    initialSortColumn="person.name"
                    columns={[
                        createComponentColumn(
                            "actions",
                            (row, index) => {
                                if (isDisabled()) return <div/>;
                                return (
                                    <Grid container spacing={1} justify="center">
                                        <Grid item>
                                            <EATableActionButton id={"zustaendigePersonen-edit-" + index} iconName="ico-edit">
                                                <span
                                                    onClick={() => handlePersonEdit(index)}
                                                    className={"w-100"}
                                                    style={{
                                                        height: "100%",
                                                        display: "block",
                                                    }}
                                                />
                                            </EATableActionButton>
                                        </Grid>
                                        <Grid item>
                                            <EATableActionButton id={"zustaendigePersonen-delete-" + index} iconName="ico-delete">
                                                <span
                                                    onClick={() => handlePersonDelete(index)}
                                                    className={"w-100"}
                                                    style={{
                                                        height: "100%",
                                                        display: "block",
                                                    }}
                                                />
                                            </EATableActionButton>
                                        </Grid>
                                    </Grid>
                                );
                            },
                            "",
                            null,
                            {width: "50px", padding: "0"}
                        ),
                        createCalculatedColumn(
                            "person.name",
                            (row) => {
                                return <label>{row.person.vorname + " " + row.person.name}</label>;
                            },
                            "Name"
                        ),
                        createCalculatedColumn(
                            "person.zust",
                            (row) => {
                                return <label>{_.toString(row.zustaendig.map((zu) => zu.value))}</label>;
                            },
                            "Zuständigkeit"
                        ),
                    ]}
                    data={props.data.zustaendigePersonen}
                />
            </div>
            {props.errors && props.errors.zustaendigePersonen && (
                <FormHelperText id="zustaendigePersonen-helper-text" error>
                    {props.errors.zustaendigePersonen}
                </FormHelperText>
            )}
            <div style={{gridColumnStart: "2", placeSelf: "end"}}>
                {props.formFactory.renderButton(
                    "addZustaendigkeitPerson",
                    "addZustaendigkeitPerson",
                    "Hinzufügen",
                    () => {
                        setPersonIndex(-1);
                        handleClickPersonOpen();
                    },
                    {
                        "data-cy": "addZustaendigkeitPerson",
                    }
                )}
            </div>
            <div style={{gridColumn: "span 2"}}>Zuständigkeiten Behörde</div>
            <div style={{gridColumn: "span 2"}}>
                <EATable
                    id="zustaendigeBearbeiter"
                    initialSortColumn="bearbeiter.name"
                    columns={[
                        createComponentColumn(
                            "actions",
                            (row, index) => {
                                if (isDisabled() || !userHasAnyRole([SYSTEMADMIN, FACHADMIN, ZUST_SBD])) return <div/>;
                                return (
                                    <Grid container spacing={1} justify="center">
                                        <Grid item>
                                            <EATableActionButton id={"zustaendigeBearbeiter-edit-" + index} iconName="ico-edit">
                                                <span
                                                    onClick={() => handleBearbeiterEdit(index)}
                                                    className={"w-100"}
                                                    style={{
                                                        height: "100%",
                                                        display: "block",
                                                    }}
                                                />
                                            </EATableActionButton>
                                        </Grid>
                                        <Grid item>
                                            <EATableActionButton id={"zustaendigeBearbeiter-delete-" + index} iconName="ico-delete">
                                                <span
                                                    onClick={() => handleBearbeiterDelete(index)}
                                                    className={"w-100"}
                                                    style={{
                                                        height: "100%",
                                                        display: "block",
                                                    }}
                                                />
                                            </EATableActionButton>
                                        </Grid>
                                    </Grid>
                                );
                            },
                            "",
                            null,
                            {width: "50px", padding: "0"}
                        ),
                        createCalculatedColumn(
                            "bearbeiter.name",
                            (row) => {
                                return <label>{row.bearbeiter.vorname + " " + row.bearbeiter.name}</label>;
                            },
                            "Name"
                        ),
                        createCalculatedColumn(
                            "bearbeiter.zust",
                            (row) => {
                                return <label>{row.bearbeiter.funktionaleRollen}</label>;
                            },
                            "Zuständigkeit"
                        ),
                    ]}
                    data={props.data.zustaendigeBearbeiter}
                />
            </div>
            {props.errors && props.errors.zustaendigeBearbeiter && (
                <FormHelperText id="zustaendigeBearbeiter-helper-text" error>
                    {props.errors.zustaendigeBearbeiter}
                </FormHelperText>
            )}
            <div style={{gridColumnStart: "2", placeSelf: "end"}}>
                {userHasAnyRole([SYSTEMADMIN, FACHADMIN, ZUST_SBD]) &&
                    props.formFactory.renderButton(
                        "addZustaendigkeitBehoerde",
                        "addZustaendigkeitBehoerde",
                        "Hinzufügen",
                        () => {
                            setBearbeiterIndex(-1);
                            handleClickBearbeiterOpen();
                        },
                        {
                            "data-cy": "addZustaendigkeitBehoerde",
                        }
                    )}
            </div>
            {renderKontakte()}
            <EADialog
                open={dlgKontaktOpen}
                titleChildren={"Kontakt"}
                content={
                    <div style={{width: "600px"}}>
                        <PersonalDataComponent
                            person={tmpKontakt}
                            anredeOptions={anredeOptions}
                            titelOptions={titelOptions}
                            errors={errors}
                            handlePersonChanged={handleKontaktChanged}
                            additionalChildren={
                                <EATextField
                                    id="funktion"
                                    key="funktion"
                                    name="funktion"
                                    label="Funktion"
                                    type="text"
                                    value={_.get(tmpKontakt, "funktion") ? _.get(tmpKontakt, "funktion") : ""}
                                    error={_.get(errors, "funktion")}
                                    onChange={(e) => handleKontaktChanged("funktion", e.target.value)}
                                />
                            }
                        />
                    </div>
                }
                buttons={
                    <EAButtonBar>
                        <EAButton
                            id={"btnKontaktAbbrechen"}
                            data-cy={"btnKontaktAbbrechen"}
                            label={"Abbrechen"}
                            onClick={handleKontaktClose}
                        />
                        <EAButton
                            id={"btnKontaktOk"}
                            data-cy={"btnKontaktOk"}
                            color="primary"
                            label={"Übernehmen"}
                            onClick={handleKontaktCloseOk}
                        />
                    </EAButtonBar>
                }
                closeFunction={handleKontaktClose}
            />
            <EADialog
                open={dlgPersonOpen}
                titleChildren={"Person"}
                content={
                    <div style={{width: "600px"}}>
                        <Grid container>
                            <Grid item xs={true}>
                                <EACombobox
                                    id="autoPerson"
                                    label="Person"
                                    options={personenOptionen.data && personenOptionen.data.length > 0 ? personenOptionen.data : []}
                                    loading={personenOptionen.loading}
                                    value={tmpPerson}
                                    getOptionLabel={(option) => (option && option.name ? option.vorname + " - " + option.name : "")}
                                    onChange={handlePersonChange}
                                />
                            </Grid>
                            <Grid item xs={true}>
                                <EACombobox
                                    id="autoPersonZusteandigkeit"
                                    label="Zuständigkeiten"
                                    options={
                                        zustaendigkeitPersonenOptionen.data && zustaendigkeitPersonenOptionen.data.length > 0
                                            ? zustaendigkeitPersonenOptionen.data
                                            : []
                                    }
                                    getOptionLabel={(option) => (option && option.id ? option.value : "")}
                                    optionTitle="value"
                                    optionKey="id"
                                    multiple
                                    loading={zustaendigkeitPersonenOptionen.loading}
                                    value={tmpPersonZustaendigkeit}
                                    disableCloseOnSelect
                                    onChange={handlePersonZustaendigkeitChange}
                                />
                            </Grid>
                        </Grid>
                    </div>
                }
                buttons={
                    <EAButtonBar>
                        <EAButton id={"eins"} data-cy={"btnPersonAbbrechen"} label={"Abbrechen"} onClick={handlePersonClose}/>
                        <EAButton id={"ok"} data-cy={"btnPersonOk"} color="primary" label={"Übernehmen"} onClick={handlePersonCloseOk}/>
                    </EAButtonBar>
                }
                closeFunction={handlePersonClose}
            />
            <EADialog
                open={dlgBearbeiterOpen}
                titleChildren={"Bearbeiter"}
                content={
                    <div style={{width: "600px"}}>
                        <Grid container>
                            <Grid item xs={true}>
                                <EACombobox
                                    id="autoBearbeiter"
                                    label="Bearbeiter"
                                    options={bearbeiterOptionen.data && bearbeiterOptionen.data.length > 0 ? bearbeiterOptionen.data : []}
                                    value={tmpPerson}
                                    loading={bearbeiterOptionen.loading}
                                    getOptionLabel={(option) =>
                                        option && option.name ? option.vorname + " " + option.name + " - " + option.funktionaleRollen : ""
                                    }
                                    getOptionSelected={(option, value) => {
                                        if (value === null || value === "") return true;
                                        return option.datascoutId === value.datascoutId;
                                    }}
                                    onChange={handleBearbeiterChange}
                                />
                            </Grid>
                        </Grid>
                    </div>
                }
                buttons={
                    <EAButtonBar>
                        <EAButton id={"eins"} data-cy={"btnBearbeiterAbbrechen"} label={"Abbrechen"} onClick={handleBearbeiterClose}/>
                        <EAButton
                            id={"ok"}
                            data-cy={"btnBearbeiterOk"}
                            color="primary"
                            label={"Übernehmen"}
                            onClick={handleBearbeiterCloseOk}
                        />
                    </EAButtonBar>
                }
                closeFunction={handleBearbeiterClose}
            />
        </div>
    );
}

export default Zustaendigkeiten;
